"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixColors = exports.getColor = void 0;
const colormap_1 = __importDefault(require("colormap"));
function getColor(value, dataType, { alpha = 1 } = {}) {
    var _a;
    const steps = 75;
    const colormap = dataType.colormap;
    const { min, max } = colormap.reduce(({ max, min }, { value }) => ({ max: Math.max(max, value), min: Math.min(min, value) }), {
        max: colormap[0].value,
        min: colormap[0].value,
    });
    const colors = colormap_1.default({
        colormap: colormap.map(definition => (Object.assign(Object.assign({}, definition), { index: (definition.value - min) / (max - min), rgb: [definition.rgb[0], definition.rgb[1], definition.rgb[2], definition.rgb[3]] }))),
        nshades: steps,
        format: 'rgbaString',
        alpha,
    });
    const clamped = Math.max(min, Math.min(max, value));
    const percentage = (clamped - min) / (max - min);
    const color = (_a = colors[Math.round(percentage * (steps - 1))]) === null || _a === void 0 ? void 0 : _a.replace(/^(rgba\(\d+,\d+,\d+,\d+),\d+(\))$/, '$1$2');
    return color;
}
exports.getColor = getColor;
var mixColors_1 = require("./mixColors");
Object.defineProperty(exports, "mixColors", { enumerable: true, get: function () { return mixColors_1.mixColors; } });
//# sourceMappingURL=index.js.map